export default {
  wrapper: {
    flex: "1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center"
  },
  welcomeText: {
    fontWeight: "900",
    fontFamily: "Roboto",
    fontSize: "36px",
    margin: 0
  }
};



// WEBPACK FOOTER //
// ./src/components/app/home/styles.js